module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("buSBn"))).then(() => module.bundle.root('9Hor8'));